import { makeStyles } from "@material-ui/core/styles";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";

const useStyles = makeStyles(() => ({
  notificationItem: {
    padding: "10px 15px",
    borderBottom: "3px solid #CBCBCB",
  },
  notificationHead: {
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
    marginBottom: "4px",
  },
  notificationTitle: {
    color: "#000",
    fontSize: "16px",
    font: "normal normal normal 16px/18px Arial",
    letterSpacing: "0.06px",
  },
  notificationTime: {
    color: "#888888",
    font: "normal normal normal 12px/14px Arial",
    letterSpacing: "0.05px",
    marginRight: "8px",
  },
  headRight: {
    display: "flex",
    alignItems: "center",
  },
  notificationMsg: {
    color: "#888888",
    font: "normal normal normal 12px/14px Arial",
    letterSpacing: "0.05px",
  },
  deleteButton: {
    padding: 4,
    color: "#C62828",
  },
}));

interface MessageProps {
  title: string;
  time: string;
  content: string;
  onDelete?: () => void;
  deleting?: boolean;
}

const NotificationMessage: React.FC<MessageProps> = ({
  title,
  time,
  content,
  onDelete,
  deleting = false,
}) => {
  const classes = useStyles();
  return (
    <li className={classes.notificationItem}>
      <div className={classes.notificationHead}>
        <span className={classes.notificationTitle}>{title}</span>
        <div className={classes.headRight}>
          <span className={classes.notificationTime}>{time}</span>
          {onDelete ? (
            <IconButton
              className={classes.deleteButton}
              size="small"
              onClick={(event) => {
                event.stopPropagation();
                onDelete();
              }}
              disabled={deleting}
              aria-label="Delete notification"
            >
              {deleting ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <DeleteOutlineIcon fontSize="small" />
              )}
            </IconButton>
          ) : null}
        </div>
      </div>
      <div className="text-left">
        <span className={classes.notificationMsg}>{content}</span>
      </div>
    </li>
  );
};

export default NotificationMessage;
